export default "__VITE_ASSET__3a77467e__"